import { Injectable,EventEmitter } from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class DataService {
 // Name Service
constructor(){

}

 sharingData;
 saveData(str){
   console.log('save data function called' + str );
   this.sharingData=str; 
 }
 getData(){
   console.log('get data function called');
   return this.sharingData;
 }

}
export interface myData {
  name:string;
}
